module.exports = __webpack_public_path__ + "static/yiguoduan-0e34158b31eaa6e6f0d825100c138b1b.jpg";